<template>
  <div class="popup" v-cloak v-if="remindBindEmailShow">
       <div class="remind-content" id="remindEmail">
           <div class="bindEmailUp">
                <div class="bindEmailTitle">
                    <div class="remindTitle">{{$t('language.rightTopBanner.bindEmail')}}</div>
                    <div class="bindEmailClose" @click="remindBindEmailShow=false"></div>
                </div>
                <div class="bindEmailBottom">
                      <!-- <div class="gift-bg"></div> -->
                      <div class="gift-des" :class="getClass()">
                           <div class="des-div" v-html="$t('language.popup.remindBindEmail.bindEmail')">   
                           </div>
                       </div>
                       <div class="bindEmailButton" @click="openBindEmail()">
                        <div class="email-inner">
                               <div class="ic-email"></div>
                               <div style="float:left;font-weight:bold;">{{$t('language.popup.personalCenter.bindEmail')}}</div>
                        </div>
                        <!-- <div class="class-help"></div> -->
                    </div>
                </div>
           </div>
           <div class="bindEmailDown">
                <div class="bindEmailOne">
                     <div style="float:left;width:100%;height:55Px;">
                        <div class="box-title">{{$t('language.popup.remindBindEmail.coreFeatures')}}</div>
                     </div>
                     <div class="bind-email-bottom">
                          <div class="bind-email-line" :title="item" :key="index"  v-for="(item, index) in bindEmailTextArr">
                                <div class="bind-email-inner">{{item}}</div>
                          </div>
                     </div>
                </div>
                <div class="bindEmailTwo">
                    <div class="box-one">
                        <div class="one-top">
                            <div class="all-one">
                               <div class="box-title">
                                   <div class="one-color">{{$t('language.popup.remindBindEmail.tourAccount')}}</div>
                              </div>
                           </div>
                        </div>
                        <div class="one-bottom">
                              <div class="email-line" :key="index"  v-for="(item, index) in tourAccountInfo">
                                <div class="b-email-inner">
                                     <div v-if="item" class="gou"></div>
                                     <div v-if="!item" class="email-none">一</div>
                                </div>
                              </div>
                        </div>
                    </div>
                </div>
                <div class="bindEmailTwo">
                    <div class="box-two">
                        <div class="two-top">
                             <div class="all-one">
                            <div  class="box-title">
                                 <div class="two-color">{{$t('language.common.emailAccount')}}</div>
                            </div>
                             </div>
                        </div>
                         <div class="one-bottom">
                               <div class="email-line" :key="index"  v-for="(item, index) in EmailAccountInfo">
                               <div class="b-email-inner">
                                     <div v-if="item" class="gou"></div>
                                </div>
                          </div>
                        </div>
                    </div>
                </div>
           </div>
       </div>
  </div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
//提醒用户绑定邮箱弹窗
export default {
    data: function () {
        return {
            remindBindEmailShow:false,
            bindEmailTextArr:[this.$t('language.popup.remindBindEmail.connectCloud'),
                              this.$t('language.popup.remindBindEmail.viewCloud'),
                              this.$t('language.popup.remindBindEmail.uploadFile'),
                              this.$t('language.popup.remindBindEmail.downloadCloud'),
                              this.$t('language.popup.remindBindEmail.syncAndBackup'),
                              this.$t('language.popup.remindBindEmail.transferFiles')
                               ],
            tourAccountInfo:[true,true,false,false,false,false],
            EmailAccountInfo:[true,true,true,true,true,true],
            fromSign:null,//1表示copy to,2表示Paste，3表示上传
        }
},
mounted(){
      //禁用拖拽功能
      commonUtils.dragDisAble('remindEmail',this);
},
methods:{
    openBindEmail(){
      this.$parent.$parent.$refs.bindEmail.bindEmailShow = true;
      this.remindBindEmailShow=false;
      if(this.fromSign==1){
       this.$parent.$refs.copyToDialog.copyToShow=false;    
      }
    },
    getClass(){
     let className;
       if(this.$i18n.locale=='deutsch'||this.$i18n.locale=='spanish'){
           className='gift-up';
       }
       if(this.$i18n.locale=='japanese'){
           className='gift-japan';
       }
       if(this.$i18n.locale=='portuguese'){
           className='gift-portuguese';
       }
       if(this.$i18n.locale=='italian'){
           className='gift-italian';
       }
         if(this.$i18n.locale=='traditionalChinese'){
           className='gift-traditional';
       }
    return  className;
    }
}
}
</script>

<style>
.bindEmailTitle{
    height: 40Px;
}
#remindEmail{
    width: 640Px;
    height: 410Px;
}
.bindEmailBottom{
    width:100%;
    height: calc(100% - 40Px);
}
.bindEmailUp{
    width: 100%;
    height: 110Px;
    float: left;
}
.bindEmailDown{
   width: 100%;
   height: calc(100% - 110Px);
   border-radius: 5Px;
   background: #fff;
   float: left;
   padding: 10Px;
   box-sizing: border-box;
    font-family: "Calibri";
  
}
.bindEmailLeft{
    width:400Px;
    height: 100%;
    float: left;
     font-family: "Calibri";
}
.remindTitle{
  color: #fff;
  font-size: 18Px;
  text-shadow: 0.01em 2Px 0.02em rgb(109, 107, 107);
  margin-top: 15Px;
  font-weight: 900;
  height: 30Px;
  float: left;
}

.remindBottom{
    width: 100%;
    height: calc(100% - 55Px);
    margin-top: 5PX;
}

.gift-bg{
    width: 65Px;
    height: 60Px;
    float: left;
    background-image: url("../../../assets/images/remindEmail/gift.png") ;
    background-repeat: no-repeat;
}
.gift-des{
    float: left;
    width: calc(100% - 190Px);
    height: 60Px;
     color: #fff;
    font-size: 14Px;
    line-height: 20Px;
    max-width: 430Px;
    padding-right: 30Px;
}

.gift-flow{
    font-weight: bold;
    color: #fff926;
}

.bindEmailRight{
    width: calc(100% - 400Px);
    float: left;
    height: 100%;
}
.bindEmailClose{
    width: 30Px;
    height: 30Px;
     background-image: url("../../../assets/images/remindEmail/close.png") ;
    background-repeat: no-repeat;
    float: right;
    cursor: pointer;
}
.bindEmailButton{
    width: 160Px;
    height: 40Px;
    border-radius: 5Px;
    background-color: #fff926;
    margin-top: 13Px;
    display: table;
    text-align: center;
    cursor: pointer;
}
.email-inner .ic-email{
    width: 25Px;
    height: 15Px;
    background-image: url("../../../assets/images/remindEmail/icEmail.png");
    background-repeat: no-repeat;
    float: left;
    position: relative;
    top: 3Px;
}
.gou{
     width: 13Px;
    height: 11Px;
    background-image: url("../../../assets/images/remindEmail/gou.png");
    background-repeat: no-repeat;
}
.email-inner{
    vertical-align: middle;
    height: 20Px;
    display: inline-block;
    line-height: 22Px;
    position: relative;
    top: 10Px;
}
.bindEmailOne{
    width: 300Px;
    height: 260Px;
    float: left;
}
.bindEmailTwo{
    width: 140Px;
    height: 260Px;
    float: left;
    margin-left: 10Px;
    border-radius: 5Px;
}

.box-title{
    width: 100%;
    height: 55Px;
    display: table-cell;
    vertical-align: middle;
    font-size: 18Px;
    font-weight: 500Px;
}

.box-one{
     background-color:#f5faff;
     width: 100%;
     height: 100%;
     border-radius: 5Px;
}

.one-top{
     background-color:#deeeff !important;
     border-top-left-radius:5Px;
     border-top-right-radius:5Px;
}
.two-top{
    background-color:#ffeed0 !important;
    border-top-left-radius:5Px;
    border-top-right-radius:5Px;
}
.box-two{
     background-color:#fff6e7;
     width: 100%;
     height: 100%;
     border-radius: 5Px;
}
.class-help{
        width: 0;
        height: 100%;
        display: inline-block;
        vertical-align: middle;
        }
.all-one{
    text-align: center;
    display: table;
    width: 100%;
}
.one-color,.two-color{
    font-size: 18Px;
    font-weight: 500;
}

.bind-email-bottom{
    float: left;
    width: 100%;
    height: calc(100% - 55Px);
    box-sizing: border-box;
    padding-top: 10Px;
}
.bind-email-line,.email-line{
    width: 100%;
    height: 29Px;
    display: table;
}
.bind-email-inner,.b-email-inner{
    display: table-cell;
    vertical-align: middle;  
}
.bind-email-line{
    cursor: pointer;
}
.bind-email-inner{
    max-width: 300Px;
    text-overflow: ellipsis;
    overflow: hidden !important;
    white-space: nowrap !important;
}
.one-bottom{
    float: left;
    width: 100%;
    height: calc(100% - 55Px);
    box-sizing: border-box;
    padding-top: 10Px;
}
.email-line{
    text-align: center;
}
.b-email-inner{
    display: inline-block !important;
    position: relative;
    top: 5Px;
}
.email-none{
    font-size: 12Px;
    font-weight: bold;
    color: #bdbdbd;
    font-family:'Arial';
}
.gift-up{
    position: relative;
    top: -5Px;
}
.gift-japan{
    max-width: 340Px !important;
    margin-right: 55Px;
}
.gift-portuguese{
    max-width: 350Px !important;
    margin-right: 45Px;
    position: relative;
    top: -5Px;
}
.gift-italian{
    max-width: 375Px !important;
    margin-right: 20Px;
}
.gift-traditional{
    max-width: 250Px !important;
    margin-right:145Px;

}
</style>


// WEBPACK FOOTER //
// src/components/popup/personal_center_popups/remind_bind_email_popup.vue